import type { Address } from "abitype";
import { arbitrum, arbitrumSepolia, base, berachain, mainnet, plasma, sepolia } from "viem/chains";

export const NetworkEids: Record<number, number> = {
  [sepolia.id]: 40161,
  [arbitrumSepolia.id]: 40231,
  [berachain.id]: 30362,
  [arbitrum.id]: 30110,
  [mainnet.id]: 30101,
  [plasma.id]: 30383,
  [base.id]: 30184,
};

export const OUSDaiUtilityAddresses: Record<number, Address> = {
  [arbitrum.id]: "0x24a92e28a8c5d8812dcfaf44bcb20cc0babd1392",
  [sepolia.id]: "0x0f0198a70f95a2f91564f3bcb0121a745bd845f1",
};

export enum ComposeFlow {
  /**
   * ARB -> ARB
   */
  LOCAL,
  /**
   * ARB -> Other
   */
  OUTBOUND,
  /**
   * Other -> ARB
   */
  INBOUND,
  /**
   * Other -> ARB -> Other
   */
  CROSS_CHAIN,
}

export interface SendParam {
  dstEid: number; // Destination endpoint ID.
  to: Address; // Recipient address.
  amountLD: bigint; // Amount to send in local decimals.
  minAmountLD: bigint; // Minimum amount to send in local decimals.
  extraOptions: Address; // Additional options supplied by the caller to be used in the LayerZero message.
  composeMsg: Address; // The composed message for the send() operation.
  oftCmd: Address; // The OFT command to be executed, unused in default OFT implementations.
}

export const SendParamAbi =
  "(uint32 dstEid, bytes32 to, uint256 amountLD, uint256 minAmountLD, bytes extraOptions, bytes composeMsg, bytes oftCmd) sendParam";
export const DepositDataAbi = `uint256 outAmountMinimum, bytes path, ${SendParamAbi}, uint256 nativeFee`;

export const CHAINS_PEER: Record<number, number> = {
  // mainnets
  [arbitrum.id]: mainnet.id,
  [mainnet.id]: arbitrum.id,
  // testnets
  [arbitrumSepolia.id]: sepolia.id,
  [sepolia.id]: arbitrumSepolia.id,
};
